import { useState, useEffect } from 'react';
import "./CommentCard.css";
import { iconPath, QuestionComment } from 'effno-core';
import { useDispatch, useSelector } from 'react-redux';
import { selectUIStates, selectUser, setSelectedComment, setUIStates } from '../../redux/features/appData';
import { PublicDetails } from '../response-content/ResponseContent';
import { CommentAvatar } from './CommentAvatar';
import { ICONS } from '../shared/media';
import { ArrowUp, Check } from 'lucide-react';

type CommentCardProps = {
    comments: QuestionComment[] | undefined;
    comment: QuestionComment;
    allowReply: boolean;
    onComplete: (id: string) => void;
    onReply: (id: string, text: string) => void;
}

export const CommentCard = ({comments, comment, allowReply = true, onComplete, onReply} : CommentCardProps) => {

    const dispatch = useDispatch();
    
    const storeUser = useSelector(selectUser);
    const uiStates = useSelector(selectUIStates);

    
    const [commentText, setCommentText] = useState<string>(""); 
    
    const children: QuestionComment[] = (comments && comment) ? comments.filter((c: QuestionComment) => {
        return c.parentQuestionCommentId === comment.id 
    }) : [];

    const publicDetails : PublicDetails | undefined = (comment.publicName && comment.publicEmail) ? 
        {
            publicName: comment.publicName,
            publicEmail: comment.publicEmail
        } : undefined;

    return (
        <>
            {comments && 
                <div 
                    className="comment-card"
                    onClick={()=> {
                        dispatch(setSelectedComment({...comment}))
                        dispatch(setUIStates({
                            ...uiStates,
                            commentMode: true,
                            viewingComment: true,
                            mobileLayout: false,
                        }))
                    }}
                >
                    <div className="comment-card-comment">
                        <div className="comment-card-meta">
                            <CommentAvatar publicDetails={publicDetails} user={comment.user}/>
                              
                            <div className="comment-card-user">
                                {publicDetails &&
                                    <>
                                        {publicDetails.publicName ? publicDetails.publicName : ""}
                                    </>
                                }
                                {!publicDetails &&
                                    <>
                                        {comment.user?.firstName} {comment.user?.lastName}
                                    </>
                                }
                            </div>
                           
                        </div>

                        <div className="comment-card-content">
                            {comment.comment}
                        </div>
                    </div>

                    {allowReply &&
                        <>
                            {children.length > 0 && children.map((child) => {

                                const childPublicDetails : PublicDetails | undefined = 
                                    (comment.publicName && comment.publicEmail) ? 
                                        {
                                            publicName: comment.publicName,
                                            publicEmail: comment.publicEmail
                                        } : undefined;
                                
                                return (
                                    <div className="comment-card-reply">
                                        <CommentAvatar publicDetails={childPublicDetails} user={comment.user}/>
                              
                                        <div className="comment-card-user">
                                            {childPublicDetails &&
                                                <>
                                                    {childPublicDetails.publicName ? childPublicDetails.publicName : ""}
                                                </>
                                            }
                                            {!childPublicDetails &&
                                                <>
                                                    {comment.user?.firstName} {comment.user?.lastName}
                                                </>
                                            }
                                        </div>

                                        <div className="comment-card-content">
                                            {child.comment}
                                        </div>
                                    </div>
                                )
                            })}
                            

                            <div className="comment-card-new-comment">
                                <CommentAvatar publicDetails={publicDetails} user={storeUser}/>
                                
                                <div className="comment-card-user">
                                    {publicDetails &&
                                        <>
                                            {publicDetails.publicName ? publicDetails.publicName : ""}
                                        </>
                                    }
                                    {!publicDetails &&
                                        <>
                                            {storeUser?.firstName} {storeUser?.lastName}
                                        </>
                                    }
                                </div>
                               
                                <div className="comment-card-content">
                                    <textarea 
                                        autoFocus={true}
                                        placeholder="Add a comment..." 
                                        value={commentText}
                                        onChange={(e) => setCommentText(e.target.value)}
                                    />
                                </div>

                                <div className="comment-card-actions">
                                    <button
                                        disabled={!commentText}
                                        onClick={()=>onReply(comment.id, commentText)}
                                    >
                                        Comment
                                    </button>
                                </div>
                            </div>
                        </>
                    }   

                    {!allowReply &&
                        <div className="comment-card-collapses-replies">
                            {children.length > 0 ? `${children.length} replies` : ""}
                        </div>
                    }

                    <div 
                        className="comment-card-icons"
                    >
                        {comment && 
                            <div 
                                className="comment-card-icons-complete"
                                onClick={(e: any)=> {
                                    e.stopPropagation();
                                    onComplete(comment.id)
                                }}
                            >
                                <Check size={12} color="#14ae5c"/>
                            </div>
                            // <img 
                            //     src={iconPath(ICONS.CHECKBOX, storeUser)} 
                            //     alt=""
                            //     onClick={(e: any)=> {
                            //         e.stopPropagation();
                            //         onComplete(comment.id)
                            //     }}
                            // />
                        }
                    
                    </div>
                </div>
            }
        </>
    )
}